<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.commonterms.set_propperties')"
      :externaltrigger="dialogtrigger" :external-close-trigger="closetrigger">

      <template v-slot:content>
        <v-container :key="dialogtrigger">
          <div class="mb-3">
            {{ $t('servicesystem.common_objects.commonterms.set_propperties_hint') }}
          </div>

          <template v-if="propperties && propperties[0]">
            <v-form v-model="valid">
              <v-card outlined flat :key="propperties.length">
                <v-row v-for="(row, index) in propperties" :key="index" no-gutters class="px-2 pb-3" align="end">
                  <v-col cols="4">
                    <QAutoComplete :value="row.key" :list="[row, ...availablePropperties]" :textkey="'label'"
                      :valuekey="'key'" externaledit :disabled="!nextPropperty"
                      @change="e => changeRowKey(index, row, e)">
                    </QAutoComplete>
                  </v-col>
                  <v-col class="px-3">
                    <template v-if="row.key">
                      <component :is="row.component" :key="row.key" v-model="row.value"
                        :placeholder="$t('servicesystem.common_objects.commonterms.empty_value')" externaledit
                        :clearable="row.clearable" :maxlength="row.maxlength">
                      </component>
                    </template>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn icon small @click="removePropperty(row.key)">
                      <v-icon size="20">mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-form>
          </template>

          <v-btn v-if="nextPropperty" color="quaternary" dark class="my-3 px-2" style="text-transform: none;"
            @click="addPropperty()">
            <v-icon size="20" class="mr-2">
              mdi-plus
            </v-icon>
            {{ $t('servicesystem.common_objects.commonterms.add_another_property') }}
          </v-btn>

        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++" color="primary" outlined
          v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn :loading="loading" :disabled="!hasPropperties || !valid"
          :color="valid && hasPropperties ? 'tertiary' : 'disabled'" :dark="valid && hasPropperties"
          @click="(valid && hasPropperties && !loading) ? save() : null">
          {{ $t('servicesystem.common_objects.commonterms.apply') }}
        </v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import Vue from "vue";
import QDateField3 from "../Inputs/QDateField3.vue";

export default {
  name: "SetProppertyDialog",
  props: {
    externaltrigger: Number,
    proppertyOptions: Object,
    saveFunction: Function,
  },
  components: {
    SlottedDialog,
    QDateField3,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      valid: false,
      loading: false,
      editObject: {},
      
      propperties: [],
    };
  },

  methods: {
    async save() {
      this.loading = true;
      var dto = this.propperties.reduce(
        (obj, item) => Object.assign(obj, { [item.key]: item.value }),
        {}
      );
      await this.saveFunction(dto)
        .then(() => {
          this.closetrigger++;
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.loading = false;
        });
    },

    addPropperty() {
      this.propperties.push(this.nextPropperty);
    },

    changeRowKey(index, row, key) {
      var newPropperty = this.proppertyOptions[key];
      newPropperty.key = key;
      const oldType = row.type;
      const oldValue = row.value;
      row = Object.assign({}, newPropperty);
      //keep old value if 
      if (row.type == oldType) {
        row.value = oldValue;
      }
      Vue.set(this.propperties, index, row)
    },

    removePropperty(key) {
      this.propperties = this.propperties.filter(x => x.key != key);
    },
  },

  computed: {
    availablePropperties() {
      var props = this.propperties;
      var list = Object.keys(this.proppertyOptions).filter(function (key) {
        return !props?.some(x => x.key == key);
      });
      return list.map(x => {
        return { key: x, ...this.proppertyOptions[x] };
      });
    },

    nextPropperty() {
      return this.availablePropperties && this.availablePropperties[0];
    },

    hasPropperties() {
      return !!(this.propperties && this.propperties.length);
    }
  },

  watch: {
    externaltrigger: function () {
      //console.log("external|trigger", this.externaltrigger);
      this.propperties = [];
      this.addPropperty();
      this.dialogtrigger++;
    },
  },
};
</script>